<template>
  <main>
    <MainArchive />
  </main>
</template>

<script>
import { constantsComputed } from '@/store/helpers'
import { getBaseURL, getBaseMetaCurrentYear } from '@/environments'

const MainArchive = () => import('@/components/Archive/Main')

export default {
  components: {
    MainArchive
  },

  created () {
    // window.window.open('https://stg-twf.admanawards.com/oldsite/archive-2018/')

    // this.$rout.go(-1)
  },

  computed: {
    ...constantsComputed
  },

  metaInfo: {
    meta: [
      { name: 'publisher', content: 'admanawards.com/' },
      { name: 'og:url', content: getBaseURL() },
      { name: 'og:title', content: `Adman Awards & Symposium ${getBaseMetaCurrentYear}` },
      { name: 'og:description', content: 'Be the First Winner of the Most Honorable Award' },
      { name: 'og:image', content: `${getBaseURL()}/img/og_adman.jpg` },
      { name: 'og:site_name', content: 'AdmanAwards' },
      { name: 'og:type', content: 'website' }
    ]
  }
}
</script>
